import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authApi } from '../lib/api';

type State = 'checking' | 'ok' | 'login' | 'setup';

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<State>('checking');
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await authApi.me();
        if (!cancelled) setState('ok');
      } catch {
        try {
          const status = await authApi.status();
          if (!cancelled) setState(status.needsSetup ? 'setup' : 'login');
        } catch {
          if (!cancelled) setState('login');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'checking') {
    return (
      <main className="min-h-screen bg-page text-fg flex items-center justify-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-faint">
          Checking session…
        </span>
      </main>
    );
  }
  if (state === 'setup') {
    return <Navigate to="/admin/setup" replace state={{ from: location }} />;
  }
  if (state === 'login') {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
